export default function Footer() {
  return (
    <footer className="footer">
      Contact Info • Policy Information
    </footer>
  );
}
